<script lang="ts">
	import { cn } from '$lib/utils';
	import type { HTMLAttributes } from 'svelte/elements';
	import type { Snippet } from 'svelte';

	interface Props extends HTMLAttributes<HTMLDivElement> {
		class?: string;
		children: Snippet;
	}

	let { class: className, children, ...props } = $props<Props>();
</script>

<div class={cn('container mx-auto px-4 md:px-6', className)} {...props}>
	{@render children()}
</div>
